import React, { useContext, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import styles from '../Cart/cart.module.css';
import { VscChromeClose } from 'react-icons/vsc';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { StoreContext } from '../../../context/StoreContext';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'gatsby';
import cartLinks from '../../Constants/cartLinks';

const Cart = ({ cartIsOpen, cartHandler }) => {
	const { o } = useSpring({ o: cartIsOpen ? 0 : -100 });

	const {
		checkout,
		removeProductFromCart,
		checkCoupon,
		removeCoupon,
		increaseQuantity,
		decreaseQuantity
	} = useContext(StoreContext);

	const [ coupon, setCoupon ] = useState('');

	const increase = (id, existingQuantity) => {
		const lineItemsToUpdate = [ { id: id, quantity: (existingQuantity += 1) } ];
		increaseQuantity(lineItemsToUpdate);
	};

	const decrease = (id, existingQuantity) => {
		const lineItemsToUpdate = [ { id: id, quantity: (existingQuantity -= 1) } ];
		decreaseQuantity(lineItemsToUpdate);
	};

	const removeCouponCode = (x) => {
		removeCoupon(x);
		setCoupon('');
	};

	return (
		<Row>
			<animated.div
				className={styles.cartWrapper}
				style={{
					transform: o.interpolate((o) => `translate3d(${o}%,0,0`)
				}}
			>
				{checkout.lineItems.length > 0 ? (
					<Col xs={12} md={10}>
						<Row>
							<Col xs={12}>
								<h1 className={styles.title}>YOUR CART</h1>
							</Col>

							{checkout.lineItems.map((item) => (
								<Col className={styles.itemHolder} xs={12}>
									<Row className={styles.itemHolderRow}>
										<Col xs={4} md={2} className={styles.imageHolder}>
											<img src={item.variant.image.src} alt="" className={styles.image} />
										</Col>
										<Col xs={6} md={8} className={styles.priceHolder}>
											<p className={styles.itemTitle}>
												<strong>{item.title}</strong>
											</p>
											<p className={styles.price}>Variant: {item.variant.title}</p>
											<p className={styles.price}>Price: £{item.variant.price}</p>
											<span style={{ display: 'flex' }}>
												Quantity:
												<button
													onClick={() => decrease(item.id, item.quantity)}
													className={styles.button1}
												>
													-
												</button>
												{item.quantity}
												<button
													onClick={() => increase(item.id, item.quantity)}
													className={styles.button2}
												>
													+
												</button>
											</span>
										</Col>

										<Col xs={2} className={styles.closeHolder}>
											<VscChromeClose
												onClick={() => removeProductFromCart(item.id)}
												className={styles.close}
											/>
										</Col>
									</Row>
								</Col>
							))}

							<Col xs={12}>
								<Row className={styles.checkoutDetails}>
									<Col md={4} xs={12} className={styles.linkHolder}>
										<strong>
											<p>
												Want to make sure what you are buying is the best for you? You might
												want to see our :
											</p>
										</strong>
										<ul className={styles.links}>
											{cartLinks.map((link) => (
												<Link to={link.path} className={styles.link}>
													{link.text}
												</Link>
											))}
										</ul>
									</Col>
									<Col md={4} xs={12} className={styles.couponHolder}>
										{checkout.lineItems.length > 0 ? (
											<Row className={styles.couponRow}>
												{checkout.discountApplications.length > 0 ? (
													<React.Fragment>
														<Col className={styles.couponSuccess}>
															<strong>
																Nice! You just applied
																<span style={{ margin: '0rem 0.3rem' }}>
																	{checkout.discountApplications[0].code}
																</span>
																to get{' '}
																{checkout.discountApplications[0].value.percentage}%
																off!
															</strong>
														</Col>
														<Col xs={12} className={styles.removeCouponBtnHolder}>
															<button
																className={styles.removeCouponBtn}
																onClick={() =>
																	removeCouponCode(
																		checkout.discountApplications[0].code
																	)}
															>
																Remove
															</button>
														</Col>
													</React.Fragment>
												) : (
													<form
														onSubmit={(e) => {
															e.preventDefault();
															checkCoupon(coupon);
														}}
														className={styles.form}
													>
														<div className={styles.label}>
															<label htmlFor="coupon">
																<strong>Do you have any coupon code from us?</strong>
															</label>
															<input
																className={styles.input}
																id="coupon"
																value={coupon}
																onChange={(e) => setCoupon(e.target.value)}
																type="text"
																placeholder="Enter your coupon code"
															/>
														</div>
														<button className={styles.couponBtn}>Add Coupon</button>
													</form>
												)}

												<div className={styles.checkoutHolder}>
													<p className={styles.total}>
														Your subtotal for these items is £{checkout.totalPrice}
													</p>

													<a href={checkout.webUrl} className={styles.checkoutLink}>
														<button className={styles.checkoutBtn}> Checkout Now</button>
													</a>
												</div>
											</Row>
										) : null}
									</Col>
									<Col xs={12} className={styles.closeWindowHolder}>
										<AiOutlineCloseCircle
											onClick={() => cartHandler(cartIsOpen)}
											className={styles.closeWindow}
										/>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				) : (
					<Col xs={12}>
						<Row>
							<Col xs={12}>
								<h1 className={styles.emptyCart}>Your cart appears to be empty</h1>
								<p className={styles.cta}>
									You might want to jump in and take a look at our
									<Link className={styles.ctaLink} to="collections">
										Collections
									</Link>
								</p>
							</Col>

							<Col xs={12} className={styles.closeWindowHolder}>
								<AiOutlineCloseCircle
									onClick={() => cartHandler(cartIsOpen)}
									className={styles.closeWindow}
								/>
							</Col>
						</Row>
					</Col>
				)}
			</animated.div>
		</Row>
	);
};

export default Cart;
